import {IElementBase} from './base/elementBase';
import {ELEMENT} from './base/ElementTypes';
import {ISlideChangeable} from './base/slideChangeable';
import {IFontElement} from './base/fontElement';
import {IElementStaticText} from './staticText';
import {IElementHtml} from './html';
import {IElementStaticList} from './staticList';
import {IElementImage} from './image';

export type IFlipCardElements = IElementImage | IElementStaticText | IElementHtml | IElementStaticList;
export type FlipCardElementTypes = ELEMENT.IMAGE | ELEMENT.STATIC_TEXT | ELEMENT.HTML | ELEMENT.STATIC_LIST;

export interface IElementFlipCard extends IElementBase, ISlideChangeable, IFontElement {
    type: ELEMENT.FLIP_CARD;
    flipCardElement: Record<FLIP_CARD_SIDE, IFlipCardElements>;
    flipCardOnHover: boolean;
}

export enum FLIP_CARD_SIDE {
    FRONT = 'FRONT',
    BACK = 'BACK',
}
